import { render, staticRenderFns } from "./sidebar-menu.vue?vue&type=template&id=000dfe96&scoped=true"
import script from "./sidebar-menu.vue?vue&type=script&lang=js"
export * from "./sidebar-menu.vue?vue&type=script&lang=js"
import style0 from "./sidebar-menu.vue?vue&type=style&index=0&id=000dfe96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000dfe96",
  null
  
)

export default component.exports